import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getDailyLog = async (queries) => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: `/monitoring-operator/shift/activity-log?${queries}`,
  });

  return data?.data;
};

export default getDailyLog;
